import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { TranslationService } from '@sdbn/common';
import { ComponentSelectionStorageService } from 'src/tmc-common/services/component-selection-storage.service';
import { SacClientContext } from '../../model/sac-client.context';
import { SacStructure } from '../../model/sac-client.model';
import { StationGroup } from 'src/tmc-yard/client/model/station-group';
import { StationSet } from 'src/tmc-yard/client/model/station-set';
import { StructureSelectionService } from 'src/tmc-yard/common/structure-selection/structure-selection-dialog/structure-selection-dialog-service';
import { StructureSelection } from 'src/tmc-yard/common/structure-selection/structure-selection.model';
import { TmcContextService } from 'src/tmc-common/services/tmc-context.service';
import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { TransportOptionGcConnectionDialogComponent } from '../transport-option-gc-connection-dialog/transport-option-gc-connection-dialog.component';
import { StationSelection } from 'src/tmc-yard/common/model/station-selection.model';
import { ClientContextService, CommonBrowserStorageService } from '@sdbn/appclient';
import { Subscription } from 'rxjs';

const STORAGE_KEY = 'app-sac-client-container.settings';

@Component({
  selector: 'app-sac-header-container',
  templateUrl: './sac-header-container.component.html',
  styleUrls: ['./sac-header-container.component.scss']
})
export class SacHeaderContainerComponent implements OnInit, OnDestroy {

  componentId = 'sac-client';
  structuresStorageKey = 'structures';
  currentStructureStorageKey = 'currentStructure';
  settingsStorageKey = 'settings';
  modeStorageKey = 'mode';

  showOptionConnectionDialog = false;

  structures = new Array<SacStructure>();
  currentStructure: SacStructure;

  @Input() sacClientContext: SacClientContext;

  @Output() structureSelected = new EventEmitter<SacStructure>();

  modeSelectionFormGroup = new FormGroup({
    mode: new FormControl('', [])
  });

  settingsFormGroup = new FormGroup({
    highlightNewTransports: new FormControl('', []),
    notificationsEnabled: new FormControl('', []),
  });

  tmcContextSubscription: Subscription;

  private yardConfigLoaded = false;

  constructor(
    public translationService: TranslationService,
    private dialog: MatDialog,
    private structureSelectionService: StructureSelectionService,
    private tmcContextService: TmcContextService,
    private commonBrowserStorageService: CommonBrowserStorageService,
    private clientContextService: ClientContextService
  ) {


  }

  ngOnInit(): void {

    this.tmcContextSubscription = this.tmcContextService.updated.subscribe(
      yardConfig => {
        if(yardConfig != null && !this.yardConfigLoaded) {
          this.yardConfigLoaded = true;

          this.loadModeFromStorage();
          this.loadStructuresFromStorage();
          this.loadCurrentStructureFromStorage();
          this.loadSettingsFromStorage();

          this.modeSelectionFormGroup.valueChanges.subscribe(
            value => {
              this.storeModeToStorage();
              this.setSelectedModeDependentParameters();
            }
          );

          this.settingsFormGroup.valueChanges.subscribe(
            value => {
              this.sacClientContext.highlightNewTransports = value.highlightNewTransports;
              this.sacClientContext.triggerHighlightNewTransports = value.highlightNewTransports;
              this.sacClientContext.notificationsEnabled = value.notificationsEnabled;
              this.storeSettingsToStorage();
            }
          );
        }
        this.showOptionConnectionDialog = yardConfig != null &&
          yardConfig.transportOptions.filter(to => to.messagingReference != null).length > 0
      }
    );
  }

  ngOnDestroy(): void {
    // this.sacClientContext.contextReady.unsubscribe();

    if (this.tmcContextSubscription != null) {
      this.tmcContextSubscription.unsubscribe();
      this.tmcContextSubscription = null;
    }
  }

  // private storeSettings() {
  //   const settings: any = {
  //     selectionMode: this.selectedMode,
  //     notificationsEnabled: this.sacClientContext.notificationsEnabled,
  //     highlightNewTransports: this.sacClientContext.highlightNewTransports,
  //     structures: this.sacClientContext.structures,
  //     selectedStructure: this.sacClientContext.selectedStructure
  //   };
  //   this.componentSelectionStorageService.saveWidgetSelection(STORAGE_KEY, this.sacClientContext.widgetIdentifier, settings);
  // }



  private setSelectedModeDependentParameters() {
    let selectedMode = this.modeSelectionFormGroup.controls.mode.value;
    this.sacClientContext.showTransports = selectedMode === 'assign' || selectedMode === 'complex';
    this.sacClientContext.showStationUsageDetails = selectedMode === 'control' || selectedMode === 'complex';
  }

  closeStructure(structure: SacStructure) {

    const indexOf = this.structures.indexOf(structure);
    this.structures.splice(indexOf, 1);

    this.storeStructuresToStorage();

    if (indexOf === 0) {
      this.selectStructure(this.structures[0]);
    } else {
      this.selectStructure(this.structures[indexOf - 1]);
    }
  }

  selectStructure(structure: SacStructure) {

    this.currentStructure = structure;
    this.storeCurrentStructureToStorage();
    this.structureSelected.next(structure);

  }

  public showTransportOptionsGcConnectionDialog() {
    this.dialog.open(TransportOptionGcConnectionDialogComponent, {
      height: '95%',
      width: '95%',
      maxWidth: '800px',
      maxHeight: '600px',
      data: {}
    });
  }

  public addStructure() {
    this.structureSelectionService.selectStationGroupOrStationSet(new StructureSelection()).subscribe(
      value => {

        console.log('structure selection is', value);

        const selection: StructureSelection = value;
        let structure = this.getSacStructure(selection.stationGroupId, selection.stationSetId);

        console.log('structure is', structure);

        let managedStructure = this.findEqualManagedStructure(structure);

        console.log('managed structure is', managedStructure);

        if (managedStructure == null) {

          this.structures.push(structure);
          this.storeStructuresToStorage();
          this.selectStructure(structure);

        } else {

          this.selectStructure(managedStructure);

        }

      }
    );
  }

  private getSacStructure(stationGroupId: number, stationSetId: number): SacStructure {

    let stationGroup: StationGroup;
    let stationSet: StationSet;

    if(!stationGroupId && !stationSetId) {
      return null;
    }

    if (stationGroupId != null) {
      stationGroup = this.tmcContextService.findStationGroupById(stationGroupId);
      if (stationGroup == null) {
        return null;
      }
    }

    if (stationSetId != null) {
      stationSet = this.tmcContextService.findStationSetById(stationSetId);
      if (stationSet == null) {
        return null;
      }
    }



    return new SacStructure({ title: stationSet != null ? stationSet.name : stationGroup.name, stationGroup: stationGroup, stationSet: stationSet });

  }

  private findEqualManagedStructure(structure: SacStructure): SacStructure {

    for (const managedStructure of this.structures) {
      if (managedStructure.stationGroup?.id === structure.stationGroup.id && managedStructure.stationSet?.id === structure.stationSet?.id) {
        return managedStructure;
      }
    }

    return null;
  }

  private loadStructuresFromStorage() {
    const storedStructures = JSON.parse(this.commonBrowserStorageService.get(this.clientContextService.getUnit().key, this.componentId, this.structuresStorageKey));
    let structures = new Array<SacStructure>();
    for (const structure of storedStructures) {
      let sacStructure = this.getSacStructure(structure.stationGroupId, structure.stationSetId);
      if (sacStructure != null) {
        structures.push(sacStructure);
      }
    }
    this.structures = structures;
  }

  private storeStructuresToStorage() {
    let persisntence = new Array<any>();
    for (let structure of this.structures) {
      persisntence.push({ stationGroupId: structure.stationGroup?.id, stationSetId: structure.stationSet?.id });
    }
    this.commonBrowserStorageService.setPersistent(this.clientContextService.getUnit().key, this.componentId, this.structuresStorageKey, JSON.stringify(persisntence));
  }

  private loadCurrentStructureFromStorage() {
    const storedCurrentStructure = JSON.parse(this.commonBrowserStorageService.get(this.clientContextService.getUnit().key, this.componentId, this.currentStructureStorageKey));
    if (storedCurrentStructure != null) {
      let structure = this.getSacStructure(storedCurrentStructure.stationGroupId, storedCurrentStructure.stationSetId);
      if (structure != null) {
        this.selectStructure(this.findEqualManagedStructure(structure));
      } else {
        console.log('no structure available', storedCurrentStructure);

        if(this.structures.length > 0) {
          this.selectStructure(this.structures[0]);
        } else {
          this.addStructure();
        }
      }
    }
  }

  private storeCurrentStructureToStorage() {
    this.commonBrowserStorageService.setPersistent(this.clientContextService.getUnit().key, this.componentId, this.currentStructureStorageKey, JSON.stringify({ stationGroupId: this.currentStructure?.stationGroup?.id, stationSetId: this.currentStructure?.stationSet?.id }));
  }

  private loadModeFromStorage() {
    const storedMode = this.commonBrowserStorageService.get(this.clientContextService.getUnit().key, this.componentId, this.modeStorageKey);
    if (storedMode != null) {
      this.modeSelectionFormGroup.patchValue({ mode: storedMode });
    } else {
      this.modeSelectionFormGroup.patchValue({ mode: 'complex' });
    }
    this.setSelectedModeDependentParameters();
  }

  private storeModeToStorage() {
    this.commonBrowserStorageService.setPersistent(this.clientContextService.getUnit().key, this.componentId, this.modeStorageKey, this.modeSelectionFormGroup.controls['mode'].value);
  }

  private loadSettingsFromStorage() {
    const storedSettings = JSON.parse(this.commonBrowserStorageService.get(this.clientContextService.getUnit().key, this.componentId, this.settingsStorageKey));
    if (storedSettings != null) {
      let value = {
        highlightNewTransports: storedSettings.highlightNewTransports,
        notificationsEnabled: storedSettings.notificationsEnabled
      };
      this.settingsFormGroup.patchValue(value);
      this.sacClientContext.highlightNewTransports = storedSettings.highlightNewTransports;
      this.sacClientContext.triggerHighlightNewTransports = storedSettings.highlightNewTransports;
      this.sacClientContext.notificationsEnabled = storedSettings.notificationsEnabled;
    }
  }

  private storeSettingsToStorage() {
    this.commonBrowserStorageService.setPersistent(this.clientContextService.getUnit().key, this.componentId, this.settingsStorageKey, JSON.stringify({
      highlightNewTransports: this.sacClientContext.highlightNewTransports,
      notificationsEnabled: this.sacClientContext.notificationsEnabled
    }));
  }

}
